import ArrowIcon from "assets/Icons/ArrowIcon";
import React, { useRef, useState } from "react";
import { Row, Col, Form, Button, Spinner, Alert } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { ContactFormWrapper } from "./styles";
import emailjs from "@emailjs/browser";

const SERVICE_OPTIONS = [
  "Pharmacy AI",
  "Web Development",
  "Cybersecurity",
  "Bespoke Work",
  "All of the above",
];

const ContactForm = () => {
  const [searchParams] = useSearchParams();
  const serviceFromUrl = searchParams.get("service") ?? "";
  const interestFromUrl = searchParams.get("interest") ?? "";
  const initialService =
    interestFromUrl === "pharmacy-ai" || serviceFromUrl === "Pharmacy AI"
      ? "Pharmacy AI"
      : SERVICE_OPTIONS.includes(serviceFromUrl)
        ? serviceFromUrl
        : "";

  const [loading, setLoading] = useState(false);
  const [requestComplete, setrequestComplete] = useState(false);
  const [requestFail, setrequestFail] = useState(false);

  const initialFormData = {
    name: "",
    pharmacy: "",
    position: "",
    contact: "",
    email: "",
    services: initialService,
    optIn: false,
  };

  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    const emailData = {
      ...formData,
      optIn: formData.optIn ? "Yes" : "No",
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        emailData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          console.log("SUCCESS!");
          setLoading(false);
          setrequestComplete(true);
          setFormData(initialFormData);
        },
        (error) => {
          console.log("FAILED...", error.text);
          setLoading(false);
          setrequestFail(true);
        }
      );
  };

  return (
    <ContactFormWrapper id="contact-form">
      <Form ref={form} onSubmit={sendEmail}>
        <Row>
          <Col md={6} className="mt-3">
            <Form.Group controlId="formName">
              <Form.Label>Name:</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mt-3">
            <Form.Group controlId="formPharmacy">
              <Form.Label>Pharmacy:</Form.Label>
              <Form.Control
                type="text"
                name="pharmacy"
                value={formData.pharmacy}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mt-3">
            <Form.Group controlId="formPosition">
              <Form.Label>Position:</Form.Label>
              <Form.Control
                type="text"
                name="position"
                value={formData.position}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mt-3">
            <Form.Group controlId="formContactNumber">
              <Form.Label>Contact Number:</Form.Label>
              <Form.Control
                type="text"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mt-3">
            <Form.Group controlId="formEmailAddress">
              <Form.Label>Email Address:</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mt-3">
            <Form.Group controlId="formInterestedService">
              <Form.Label>Interest:</Form.Label>
              <Form.Control
                as="select"
                name="services"
                value={formData.services}
                onChange={handleChange}
                required
              >
                <option value="">Select a service</option>
                {SERVICE_OPTIONS.map((service) => (
                  <option key={service} value={service}>
                    {service}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group controlId="formOptIn" className="mt-4">
          <Form.Check
            type="checkbox"
            label="Opt in for informative emails"
            name="optIn"
            checked={formData.optIn}
            onChange={handleChange}
          />
        </Form.Group>
        <Button type="submit" className="secondary mt-5">
          {loading ? (
            <Spinner animation="border" />
          ) : (
            <>
              Submit
              <span className="arrow-icon">
                <ArrowIcon />
              </span>
            </>
          )}
        </Button>
        {requestComplete && (
          <Alert key={"success"} variant={"success"} className="mt-3">
            Message sent successfully. We’ll get back to you soon
          </Alert>
        )}
        {requestFail && (
          <Alert key={"danger"} variant={"danger"} className="mt-3">
            Something went wrong
          </Alert>
        )}
      </Form>
    </ContactFormWrapper>
  );
};

export default ContactForm;
